export default __webpack_public_path__ + "static/media/icon-gaming.ad80aabf.svg";